import bellyIcon from '../../assets/icons/belly.svg';
import notificationBellIcon from '../../assets/icons/notification-bell-v2-read.svg';
import notificationBellDotIcon from '../../assets/icons/notification-bell-v2.svg';
import { useNavigate } from 'react-router';
import { useContext, useEffect, useState } from 'react';
import useSWR from 'swr';
import { format } from 'date-fns';
import { AuthContext } from '../../context/AuthContext';
import { useAnimatedNumber } from '../../hooks/useAnimatedNumber';
import { formatKm } from '../../services/pedometerNative';
import { isNightTime } from './PlaygroundPedometerCard';

function PlaygroundTopHeader({
  showRedDot = false,
  steps,
  healthSteps,
  km,
  onStepsClick,
  overlay = false,
  showPool = true,
  /** 포인트 탭일 때 걸음수 색을 흰색으로 */
  onPointTab = false,
}) {
  const navigate = useNavigate();
  const { API_SERVER_DOMAIN } = useContext(AuthContext);
  const { data: poolInfo } = useSWR(`${API_SERVER_DOMAIN}/pool/info`, (url) =>
    fetch(url).then((res) => res.json()),
  );
  const [night, setNight] = useState(() => isNightTime());

  useEffect(() => {
    const timer = window.setInterval(() => setNight(isNightTime()), 60000);
    return () => window.clearInterval(timer);
  }, []);

  // 어드민: exposureEndDate 당일 24:00부터 미노출 → 종료일 초과 시에만 숨김
  const exposureEndDate = poolInfo?.infos?.exposureEndDate;
  const today = format(new Date(), 'yyyy-MM-dd');
  const showPoolIcon = showPool && (!exposureEndDate || today < exposureEndDate);
  const showSteps = Number.isFinite(healthSteps);
  // const showSteps = true;
  const animatedSteps = useAnimatedNumber(showSteps ? healthSteps : 0, {
    enabled: showSteps,
    // 당일 마지막 표시값 유지 → 재진입 시 증가분만 카운트업
    storageKey: showSteps ? `pdm-header-steps-${today}` : undefined,
  });
  const displayKm = showSteps ? formatKm(animatedSteps) : km;
  const stepsColor = onPointTab ? '#FFFFFF' : night ? '#E5E5E5' : '#4A4A4A';

  return (
    <div
      className={`flex w-full items-start justify-between px-3 pt-3 pb-2${
        overlay ? ' absolute inset-x-0 top-0 z-20 pointer-events-none' : ''
      }`}
    >
      {showSteps ? (
        <button
          type="button"
          className={`border-0 bg-transparent p-0 text-left outline-none${overlay ? ' pointer-events-auto' : ''}`}
          onClick={onStepsClick}
          aria-label={`${animatedSteps.toLocaleString('ko-KR')}걸음, ${displayKm}킬로미터`}
          style={{ color: stepsColor }}
        >
          {/* Figma: 작은 km 위, 큰 걸음수 아래 */}
          <div className="flex items-baseline gap-0.5">
            <span className="font-['Pretendard'] text-xs font-normal leading-none tracking-[-0.5px] tabular-nums">
              {displayKm}
            </span>
            <span className="font-['Pretendard'] text-[10px] font-normal leading-none tracking-[-0.5px]">
              km
            </span>
          </div>
          <div className="mt-0.5 flex items-end gap-1">
            <span className="font-['Pretendard'] text-[27px] font-bold leading-none tracking-[-0.5px] tabular-nums">
              {animatedSteps.toLocaleString('ko-KR')}
            </span>
            <span className="mb-[3px] font-['Pretendard'] text-xs font-normal leading-none tracking-[-0.5px] opacity-80">
              걸음
            </span>
          </div>
        </button>
      ) : (
        <div className="justify-center text-white text-[1.4375rem] font-extrabold font-['Pretendard'] [text-shadow:_0px_0px_16px_rgb(139_104_221_/_0.80)]">
          야옹상회
        </div>
      )}

      <div className={`inline-flex items-center justify-start gap-2.5${overlay ? ' pointer-events-auto' : ''}`}>
        {showPoolIcon && (
          <div
            className="pool-pill-pulse flex h-9 w-28 cursor-pointer items-center justify-center gap-1.5 rounded-[30px] bg-[#ffeb3b] px-3 py-1.5"
            onClick={() => navigate('/pool')}
          >
            <div data-layer="pool" className="Pool relative">
              <img src={bellyIcon} alt="히든밸리 아이콘" className="mt-1 h-6 w-6 brightness-0" />
            </div>
            <div
              data-layer="히든밸리"
              className="justify-center font-['Pretendard'] text-sm font-extrabold text-black"
            >
              히든밸리
            </div>
          </div>
        )}

        <button
          type="button"
          className="relative flex h-6 w-6 items-center justify-center border-0 bg-transparent p-0 outline-none"
          onClick={() => navigate('/notifications')}
          aria-label="알림"
        >
          <img
            src={showRedDot ? notificationBellDotIcon : notificationBellIcon}
            alt=""
            className="h-6 w-[22px] object-contain object-top"
          />
        </button>
      </div>
    </div>
  );
}

export default PlaygroundTopHeader;
